export const upscprelimsApiservice = async (data) => {
    const value = data;
    console.log('test2',value);
   
    
     //const token = "1|mofENkYYm3CCGM6Xdabeg5IiduoQrJIdoqd1xhlD7b004645";
     try {
       const response = await fetch("https://www.shankariasacademy.com/blog/wp-json/api/v2/tnpscgrIprelims2026", {
         method: "POST",
         headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          //'Authorization': `Bearer ${token}`,
         },
         mode: "cors",
         cache: "no-cache",
         body: JSON.stringify(
           value
         ),
       });
   
      const data = await response.json();
      return data;
      //console.log("Response:", data);
      
     } catch (error) {
       console.error("Error sending data:", error);
     }
   };



   export const upscprelimsApiserviceget = async (data) => {
    const value = data;
    console.log(value);

     //const token = "1|mofENkYYm3CCGM6Xdabeg5IiduoQrJIdoqd1xhlD7b004645";
     try {
       const response = await fetch("https://www.shankariasacademy.com/blog/wp-json/cf7/v2/upscprestorming-get", {
         method: "POST",
         headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           //'Authorization': `Bearer ${token}`,
         },
          mode: "cors",
          cache: "no-cache",
         body: JSON.stringify(
           value
         ),
       });
   
       const data = await response.json();
      // console.log("Response:", data);
      return data;
      
       //console.log("Response:", data);
      
     } catch (error) {
       console.error("Error sending data:", error);
     }
   };
   export const upscprelimsApicheck = async (data) => {
    const value = data;
    console.log(value);

     //const token = "1|mofENkYYm3CCGM6Xdabeg5IiduoQrJIdoqd1xhlD7b004645";
     try {
       const response = await fetch("https://www.shankariasacademy.com/blog/wp-json/cf7/v2/upscprestorming-usercheck", {
         method: "POST",
         headers: {
           "Content-Type": "application/json",
           "Accept": "application/json"
           //'Authorization': `Bearer ${token}`,
         },
          mode: "cors",
          cache: "no-cache",
         body: JSON.stringify(
           value
         ),
       });
   
       const data = await response.json();
       console.log("Response:", data);
      return data;
      
       //console.log("Response:", data);
      
     } catch (error) {
       console.error("Error sending data:", error);
     }
   };